export const ACTIVITY_LABELS: Record<string, string> = {
  session_start: 'Session started', page_view: 'Page viewed', listing_view: 'Listing viewed', marketplace_filter: 'Search or filter used', engagement: 'Active foreground time',
  install_prompt: 'Install prompt available', install_accepted: 'Install prompt accepted', install_dismissed: 'Install prompt dismissed', pwa_install_reported: 'Browser reported installation', pwa_launch: 'App opened', sign_out: 'Signed out',
  sign_in: 'Signed in successfully', sign_up: 'Account created', listing_created: 'Listing created', listing_updated: 'Listing updated', listing_published: 'Listing published', listing_sold: 'Listing marked sold', enquiry_sent: 'Enquiry submitted successfully', watchlist_changed: 'Watchlist changed', listing_shared: 'Listing shared',
};
export function safeAnalyticsPath(path: string): string {
  const pathname = path.split(/[?#]/)[0];
  return /^\/[a-zA-Z0-9_/-]{0,180}$/.test(pathname) ? pathname : '/';
}
export function shouldCountEngagement(visible: boolean, now: number, lastInteraction: number): boolean {
  return visible && now - lastInteraction <= 60_000 && now >= lastInteraction;
}
export function engagementSeconds(elapsedMs: number): number {
  return Math.min(15, Math.max(0, Math.round(elapsedMs / 1000)));
}
export function csvCell(value: unknown): string {
  let text = String(value ?? '');
  if (/^[=+\-@\t\r]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
}
